import "./ThemeSwitcher.scss";

import React from "react";
import { CFormSwitch } from "@coreui/react";
import { clsx } from "clsx";

import { useDarkMode } from "../hooks/useDarkMode";

export const ThemeSwitcher: React.FC = () => {
  const { isDark, setLight, setDark } = useDarkMode();

  // ON = light, OFF = dark
  // So checked should be true when theme is light (i.e., when NOT dark)
  const checked = !isDark;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setLight();
    } else {
      setDark();
    }
  };

  return (
    <div className="ThemeSwitcher">
      <span className={clsx("icon dark", isDark && "active")} title="Dark mode">
        🌚
      </span>
      <CFormSwitch
        id="theme-switch"
        checked={checked}
        onChange={handleChange}
        title={isDark ? "Switch to light theme" : "Switch to dark theme"}
        label=""
      />
      <span className={clsx("icon light", !isDark && "active")} title="Light mode">
        🌝
      </span>
    </div>
  );
};
